<template>
  <div class = 'train_evalItem'>
    <div :class="{'pic-mode': isModal}" class = 'board pointer' @click = 'onClick' style = ' position: relative'>
      <slot name = 'card'>
        <img :src = 'itemImage'/>
      </slot>
      <div style = ' position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; background: rgba(0, 0, 0, 0.3); display: flex; justify-content: center; align-items: center;' v-if = 'showIndicator'>
        <slot name = 'indicator'>
        </slot>
      </div>
    </div>
    <slot name = 'title'>
      <div>{{itemTitle}}</div>
    </slot>
  </div>
</template>

<script>
import CardListItemController from './controller';
export default new CardListItemController;
</script>
<style>
.train_evalItem{
  display: inline-block;
  margin-left: 30px;
  margin-top:30px;
}
.pic-mode{
  width:144px !important;
  height:144px !important;
}
.pic-mode img{
  width:144px !important;
}
</style>




// WEBPACK FOOTER //
// component.vue?1e1439d6